module.exports = __webpack_public_path__ + "img/moderation_wait_my.193628c6.svg";